import React from 'react';
import './404.styles.scss';

const NoMatch = () => (
    <div>
        <h1>404 Page not found</h1>
    </div>
);

export default NoMatch;